import React from 'react'
import type { PaymentOptionsHorizontalSlice } from '~/lib/prismic'
import type { SliceComponentProps } from "@commercekit/prismic";
import { asText } from "@prismicio/helpers";
import {  PrismicImage } from "@prismicio/react";


const PaymentOptionsHorizontal = ({ slice }: SliceComponentProps<PaymentOptionsHorizontalSlice>) => (
  <div className="footer__payment-logos text-center py-3">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-lg-auto">
              <div className="heading mb-3 mb-lg-0 handwritten lg">
              {asText(slice.primary.title)}
              </div>
            </div>
            <div className="col-12 col-lg-auto">
              <div className="row justify-content-center">
                <>
                  {slice.items &&
                    slice.items.map((payment) => (
                      <div
                        key={payment.text}
                        className="col-auto d-flex align-items-center justify-content-center mb-3 mb-lg-0 px-3 pb-2"
                      >
                        <div className="footer__payment-logo h-100 d-flex align-items-center justify-content-center">
                          <PrismicImage
                            field={payment.image}
                            loading="lazy"
                            widths={[]}
                          />
                        </div>
                      </div>
                    ))}
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
)

export default PaymentOptionsHorizontal
